export class ConfigurationProperty {
    static constructFromPlainObject(plainObject) {
        return new ConfigurationProperty(plainObject.key, plainObject.value, plainObject.declarer);
    }
    constructor(key, value, declarer) {
        this.key = key;
        this.value = value;
        this.declarer = declarer;
    }
    getKey() {
        return this.key;
    }
    getValue() {
        return this.value;
    }
    getDeclarer() {
        return this.declarer;
    }
}
//# sourceMappingURL=configurationProperty.js.map